(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/game-links/views/game-links-startpage-desktop.js') >= 0) return;  svs.modules.push('/components/components/game-links/views/game-links-startpage-desktop.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.game_links=_cmps.game_links||{};
_cmps.game_links.templates=_cmps.game_links.templates||{};
svs.components.game_links.templates.game_links_startpage_desktop = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials["components-components-game_links-game_link_desktop"],depth0,{"name":"components-components-game_links-game_link_desktop","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"game-link-startpage\" itemscope itemtype=\"http://schema.org/SiteNavigationElement\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true});
Handlebars.partials['components-components-game_links-game_links_startpage_desktop'] = svs.components.game_links.templates.game_links_startpage_desktop;
})(svs, Handlebars);

 })(window);